import { render, staticRenderFns } from "./EditRatesModal.vue?vue&type=template&id=593ca280&scoped=true"
import script from "./EditRatesModal.vue?vue&type=script&lang=js"
export * from "./EditRatesModal.vue?vue&type=script&lang=js"
import style0 from "./EditRatesModal.vue?vue&type=style&index=0&id=593ca280&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ca280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('593ca280')) {
      api.createRecord('593ca280', component.options)
    } else {
      api.reload('593ca280', component.options)
    }
    module.hot.accept("./EditRatesModal.vue?vue&type=template&id=593ca280&scoped=true", function () {
      api.rerender('593ca280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/EditRatesModal.vue"
export default component.exports